'use client';

import classnames from 'classnames/bind';
import React, { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { resolveUrl } from '@portal-root/geo-utils';
import { Button } from '@/_kit/button';
import { EButtonColor, EButtonSize } from '@/_kit/button/_types';
import { ArrowRightIcon } from '@/_kit/icons/arrow-right-icon';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';
import { ELinkId } from '@/_components/support/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'AllMaterialsButton';

type TProps = {
  link: string;
  buttonName: string;
};

export const AllMaterialsButton = ({ link, buttonName }: TProps) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();

  const handleButtonClick = useCallback(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_SUPPORT_T,
      params: {
        // eslint-disable-next-line camelcase
        link_name: ELinkId.ALL_MATERIALS,
      },
    };

    sendEvent(config);

    window.open(resolveUrl(link), '_blank');
  }, [link, sendEvent]);

  return (
    <div className={cn(BLOCK_NAME)}>
      <Button
        backgroundColor={EButtonColor.WHITE}
        onClick={handleButtonClick}
        rightIcon={ArrowRightIcon}
        size={EButtonSize.MEDIUM}
        strokeColor={EButtonColor.BLACK}
      >
        <Text
          size={ETextSize.SMALL}
          text={translations(buttonName)}
          variant="body"
        />
      </Button>
    </div>
  );
};
